import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Spinner,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import { formatUnitsForReport } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import StatusFilterLegend from "../../../../components/StatusFilteredLegend";
import SweetAlert from "react-bootstrap-sweetalert";

const PartialDeliveryFromCentralKitchenReport = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const [confirmClose, setConfirmClose] = useState(false);

  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [selectedRow, setSelectedRow] = useState([]);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);

  useEffect(() => {
    loadAllStores();
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setAllOrders([]);
      setFilteredData([]);
      setFilteredPO([]);
    }
  }, [dateFrom, dateTo]);

  const [selectedStore, setSelectedStore] = useState("");
  const [centralStore, setCentralStore] = useState("");
  const [allstores, setAllStore] = useState([]);
  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setCentralStore(response.data.filter((d) => d.type === "CENTRAL STORE"));
      const stores = response.data.filter((d) => d.type === "Branch") || [];
      setAllStore(stores);
    } else {
      showNotification(response.message, "Error");
      return false;
    }
  };

  const [allOrders, setAllOrders] = useState([]);
  const [filteredData, setFilteredData] = useState(allOrders);
  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 31) {
        setAllOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setAllOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      setIsLoadingOrders(true);
      const url = process.env.REACT_APP_BASEURL + "reports/item_order_update";
      const response = await postSubmitForm(url, {
        date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
        date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
        store_id: selectedStore,
      });
      if (requestId !== ordersRequestId.current) return;

      if (response && response.status === 1) {
        const result = response.data.item_order_updates || [];
        if (result.length <= 0) {
          setAllOrders([]);
          setFilteredData([]);
          setFilteredPO([]);
          showNotification("No Orders data found", "error");
          return false;
        }
        const sortedData = [...result]
          .sort(
            (a, b) =>
              new Date(a.order_created_on) - new Date(b.order_created_on),
          )
          .map((row, index) => ({
            ...row,
            row_key: row.order_id || `row_${index}`,
            branch_name:
              row.branch_details && row.branch_details.name
                ? row.branch_details.name
                : "",
          }));
        setAllOrders(sortedData);
        setFilteredData(sortedData);
        setFilteredPO(sortedData);
      } else {
        setAllOrders([]);
        setFilteredData([]);
        setFilteredPO([]);
        showNotification((response && response.message) || "Error", "Error");
        return false;
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
      console.log(error);
      return false;
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  const handleTransfer = async () => {
    const transferableItems = selectedRow.items
      .filter(
        (item) =>
          item.update_type === "QUANTITY" && item?.balance_quantity?.length > 0,
      )
      .map((item) => {
        return {
          item_id: item.new_item_details?.item_id,
          name: item.new_item_details?.name,
          category: item.new_item_details?.category,
          sub_category: item.new_item_details?.sub_category,
          brand: item.new_item_details?.brand,
          quantity: item.balance_quantity.map(({ unit, value }) => ({
            unit,
            value: parseFloat(value),
          })),
          unit_levels: item.new_item_details?.unit_levels,
        };
      });
    // console.log(transferableItems,"Transferrable Items");

    const uniqueItems = transferableItems?.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.item_id === item.item_id),
    );
    // console.log(uniqueItems,"UI");

    if (uniqueItems?.length > 0) {
      const payload = {
        items: uniqueItems,
        order_id: selectedRow.order_id,
        store_id: selectedRow.branch_details?._id,
        remarks: selectedRow?.order_id,
      };
      // console.log(payload, "Payload");
      // return;
      let url =
        process.env.REACT_APP_BASEURL +
        "storesitemstransfer/direct_balance_transfer";
      let response = await postSubmitForm(url, payload);
      {
        if (response && response.status === 1) {
          showNotification("Items transferred successfully", "Success");
          setSelectedRow();
          loadOrders();
        } else {
          showNotification(response.message || "Error", "Error");
          return false;
        }
      }
    } else {
      showNotification("No items available for transfer", "Warning");
      return false;
    }
  };

  function editFormatter(cell, row) {
    return (
      <>
        <span className="mr-2">
          <i
            className="bx bx-transfer-alt font-size-15"
            title="Transfer Items"
            hidden={
              row.order_status !== "Partially Received" &&
              row.order_status !== "PO is pending"
            }
            style={{ cursor: "pointer" }}
            onClick={() => {
              setConfirmClose(true);
              setSelectedRow(row);
            }}
          ></i>
        </span>
        <span className=" mr-2">
          <i
            className="mdi mdi-text-box-search font-size-15"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedRow(row);
              setOrderDetailsModal(true);
            }}
          ></i>
        </span>
      </>
    );
  }
  const [filteredPO, setFilteredPO] = useState([]);

  function afterFilter(newResult, newFilters) {
    setFilteredPO((prevOrders) => {
      const next = newResult || [];
      if (
        prevOrders.length === next.length &&
        prevOrders.every((row, index) => row === next[index])
      ) {
        return prevOrders;
      }
      return next;
    });
  }
  const columns = [
    {
      dataField: "row_key",
      hidden: true,
    },
    {
      dataField: "serial",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Order"),
      dataField: "order_id",
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedRow(row);
              setOrderDetailsModal(true);
            }}
          >
            {row.order_id}
          </span>
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "branch_name",
      text: props.t("Branch Name"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "17%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              (filteredData || [])
                .filter((row) => row && row.branch_name)
                .map((row) => [
                  row.branch_name,
                  { value: row.branch_name, label: row.branch_name },
                ]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
      style: { cursor: "pointer" },
    },

    {
      dataField: "order_created_on",
      text: props.t("Order Date"),
      formatter: (cell, row) => {
        let date = row.order_created_on;
        return date ? moment(date).format("DD/MM/YYYY HH:mm") : " ";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "total_items_updated",
      text: props.t("Total Updated Items"),
      formatter: (cell, row) => {
        return row.total_items_updated;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Status"),
      dataField: "order_status",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              (filteredData || [])
                .filter((row) => row && row.order_status)
                .map((row) => [
                  row.order_status,
                  { value: row.order_status, label: row.order_status },
                ]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
    },
    {
      text: props.t("Action"),
      dataField: "action",
      isDummyField: true,
      formatter: editFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
  ];

  const [orderDetailsModal, setOrderDetailsModal] = useState();

  const rowStyle = (row, rowIndex) => {
    let backgroundColor = row.background_color || "";
    return { backgroundColor: backgroundColor };
  };

  const handleDownload = async () => {
    const fileName = "Order Update Logs Report";
    const exportType = "xls";
    let data_to_export =
      filteredPO && filteredPO.length
        ? filteredPO
        : filteredData && filteredData.length
          ? filteredData
          : allOrders;
    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Order: v.order_id,
          Branch_Name: v.branch_name,
          Total_Updated_Items: v.total_items_updated,
          Status: v.order_status,
          Order_Date: moment(v.order_created_on).format("DD/MM/YYYY HH:mm"),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    sizePerPage: pageSize,
    onSizePerPageChange: (sizePerPage) => {
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const columns_items = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "branch_ordered_quantity",
      sort: true,
      formatter: (cell, row) => {
        const name =
          row.update_type === "DELETE"
            ? row.deleted_item_details?.category
            : row.new_item_details.category;
        return name;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "branch_ordered_quantity",
      sort: true,
      formatter: (cell, row) => {
        const name =
          row.update_type === "DELETE"
            ? row.deleted_item_details?.name
            : row.new_item_details.name;
        return name;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },

    {
      dataField: "branch_ordered_quantity",
      text: props.t("Initial Order Qty."),
      formatter: (cell, row) => {
        let ordered = row.branch_ordered_quantity || [];
        return ordered.length === 0
          ? " "
          : formatUnitsForReport(row.branch_ordered_quantity);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "central_dispatch_quantity",
      text: props.t("Dispatch Qty."),
      formatter: (cell, row) => {
        let dispatched = row.central_dispatch_quantity || [];
        return dispatched.length === 0
          ? " "
          : formatUnitsForReport(row.central_dispatch_quantity);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "branch_received",
      text: props.t("Received Qty."),
      formatter: (cell, row) => {
        let received = row.branch_received?.quantity || row.branch_received;
        return received.length === 0 ? " " : formatUnitsForReport(received);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "balance_quantity",
      text: props.t("Balance Qty."),
      formatter: (cell, row) => {
        let balance = row.balance_quantity || [];
        return balance.length === 0 ? " " : formatUnitsForReport(balance);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "remark",
      text: props.t("Remarks"),
      formatter: (cell, row) => {
        if (!row.remark) return "";
        if (row.remark.toLowerCase().includes("partial")) {
          return <b>{row.remark}</b>;
        }
        return row.remark;
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Order Update Logs Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Order Update Logs Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="store"
                          label={props.t("Branch")}
                          type="select"
                          value={selectedStore}
                          onChange={(e) => {
                            setSelectedStore(e.target.value);
                          }}
                        >
                          <option value="">{props.t("All")}</option>
                          {allstores &&
                            allstores.map((store) => {
                              return (
                                <option key={store._id} value={store._id}>
                                  {store.name}
                                </option>
                              );
                            })}
                        </AvField>
                      </Col>
                      <Col lg={3}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md={12} style={{ display: "flex", justifyContent: "center" }}>
              <StatusFilterLegend
                data={allOrders}
                onFilterChange={(newFilteredData) =>
                  setFilteredData(newFilteredData)
                }
              />
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                    <Col lg={8}></Col>
                  </Row>
                  <div id="printDiv">
                    <ToolkitProvider
                      keyField="row_key"
                      data={filteredData && filteredData}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <CardTitle className="text-center">
                                Order Update Logs Report
                              </CardTitle>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            rowStyle={rowStyle}
                            pagination={paginationFactory(pagination_options)}
                            filter={filterFactory({ afterFilter })}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="xl"
                    isOpen={orderDetailsModal}
                    toggle={() => setOrderDetailsModal(!orderDetailsModal)}
                  >
                    <ModalHeader
                      toggle={() => setOrderDetailsModal(!orderDetailsModal)}
                    >
                      {props.t("Order Update Details")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col md={6}>
                                    <Link
                                      to="#"
                                      onClick={() => {
                                        printDiv("printUpdate");
                                      }}
                                      className="btn btn-sm btn-success mr-2"
                                    >
                                      <i className="fa fa-print"></i> Print
                                    </Link>
                                  </Col>
                                  <div id="printUpdate">
                                    {/* <Col lg={12} md={12}>
                                    <Label>Update Details</Label>
                                  </Col> */}

                                    <Col lg={12}>
                                      <BootstrapTable
                                        bootstrap4
                                        keyField="name"
                                        data={
                                          (selectedRow && selectedRow.items) ||
                                          []
                                        }
                                        columns={columns_items}
                                        noDataIndication="No data to display."
                                        striped
                                        rowStyle={rowStyle}
                                        hover
                                        condensed
                                      />
                                      <hr />
                                    </Col>
                                  </div>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
              {/* ---Close Reamarks Modal Start--- */}
              {confirmClose && (
                <SweetAlert
                  title={props.t("Are you sure?")}
                  warning
                  showCancel
                  cancelBtnText={props.t("No")}
                  confirmBtnText={props.t("Yes")}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => {
                    setConfirmClose(false);
                    handleTransfer();
                  }}
                  onCancel={() => {
                    setSelectedRow();
                    setConfirmClose(false);
                  }}
                >
                  {props.t("Once you transfer, it cannot be revoked.")}
                </SweetAlert>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(
    mapStatetoProps,
    {},
  )(withNamespaces()(PartialDeliveryFromCentralKitchenReport)),
);
